(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leb-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var input = root.querySelector('input'), list = root.querySelector('.leb-finder__list'), panel = root.querySelector('.leb-finder__panel');
      var wa = root.dataset.wa, data = null, items = [], active = -1;
      function load() { if (data) return Promise.resolve(data); return fetch(root.dataset.index).then(function (r) { return r.json(); }).then(function (d) { data = d; return d; }).catch(function () { data = []; return data; }); }
      function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function waLink(bike) { return 'https://wa.me/' + wa + '?text=' + encodeURIComponent('Hi, I ride a ' + bike + '. What parts do you have for it?'); }
      function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
      function showPanel(bike) {
        close(); panel.hidden = false;
        panel.querySelector('.leb-finder__panel-h').textContent = 'We fit parts to ' + bike + ' bikes';
        panel.querySelector('.leb-finder__wa').href = waLink(bike);
      }
      function choose(e) { if (!e) return; if (e.u) { window.location.href = e.u; } else { showPanel(e.l); input.value = e.l; } }
      function render(q) {
        panel.hidden = true;
        var t = q.trim().toLowerCase();
        if (!t) { close(); return; }
        var words = t.split(/\s+/);
        items = data.filter(function (e) { var l = e.l.toLowerCase(); return words.every(function (w) { return l.indexOf(w) !== -1; }); });
        function score(e) { var l = e.l.toLowerCase(); return (l === t ? 4 : 0) + (l.indexOf(t) !== -1 ? 2 : 0) + (l.indexOf(t) === 0 ? 1 : 0); }
        items.sort(function (a, b) { return score(b) - score(a) || b.n - a.n; }); items = items.slice(0, 8);
        var html = items.map(function (e, i) {
          var label = esc(e.l), lw = e.l.toLowerCase(), pos = lw.indexOf(words[0]);
          if (pos !== -1) label = esc(e.l.slice(0, pos)) + '<mark>' + esc(e.l.slice(pos, pos + words[0].length)) + '</mark>' + esc(e.l.slice(pos + words[0].length));
          var meta = e.n ? e.n + ' parts' : 'Ask us';
          return '<li role="option" id="lebopt' + i + '" aria-selected="false" data-i="' + i + '">' + '<span>' + label + '</span><small>' + esc(e.k) + ' · ' + meta + '</small></li>';
        }).join('');
        html += '<li role="option" id="lebopt' + items.length + '" aria-selected="false" data-ask="1"><span>Can’t see it? Send us &ldquo;' + esc(q.trim()) + '&rdquo;</span><small>WhatsApp</small></li>';
        list.innerHTML = html; list.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
      }
      function move(d) {
        var opts = list.querySelectorAll('li'); if (!opts.length) return;
        if (active >= 0) opts[active].setAttribute('aria-selected', 'false');
        active = (active + d + opts.length) % opts.length; opts[active].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', opts[active].id); opts[active].scrollIntoView({ block: 'nearest' });
      }
      function pick(li) { if (!li) return; if (li.dataset.ask) { window.open(waLink(input.value.trim()), '_blank', 'noopener'); return; } choose(items[+li.dataset.i]); }
      input.addEventListener('focus', function () { load(); });
      input.addEventListener('input', function () { load().then(function () { render(input.value); }); });
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown') { ev.preventDefault(); move(1); }
        else if (ev.key === 'ArrowUp') { ev.preventDefault(); move(-1); }
        else if (ev.key === 'Enter') { ev.preventDefault(); var opts = list.querySelectorAll('li'); if (active >= 0) pick(opts[active]); else if (items.length) choose(items[0]); else if (input.value.trim()) pick(list.querySelector('[data-ask]')); }
        else if (ev.key === 'Escape') { close(); }
      });
      list.addEventListener('mousedown', function (ev) { var li = ev.target.closest('li'); if (li) { ev.preventDefault(); pick(li); } });
      document.addEventListener('click', function (ev) { if (!root.contains(ev.target)) close(); });
    }
    function boot() { document.querySelectorAll('[data-leb-finder]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(hero) {
      if (hero.dataset.ready) return; hero.dataset.ready = '1';
      var slides = [].slice.call(hero.querySelectorAll('.leb-hero__slide')), tabs = [].slice.call(hero.querySelectorAll('.leb-hero__tab'));
      var pause = hero.querySelector('[data-leb-pause]'), reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, running = !reduced, inView = true, timer = null, raf = null;
      function vid(n) { return slides[n] && slides[n].querySelector('video'); }
      function progress() { var v = vid(i), bar = tabs[i] && tabs[i].querySelector('i'); if (bar && v && v.duration) bar.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')'; raf = requestAnimationFrame(progress); }
      function show(n) {
        var prev = vid(i); if (prev) prev.pause();
        slides[i].classList.remove('is-active'); if (tabs[i]) { tabs[i].classList.remove('is-active'); tabs[i].setAttribute('aria-selected', 'false'); }
        tabs.forEach(function (t) { var b = t.querySelector('i'); if (b) b.style.transform = 'scaleX(0)'; });
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (tabs[i]) { tabs[i].classList.add('is-active'); tabs[i].setAttribute('aria-selected', 'true'); }
        var v = vid(i); clearTimeout(timer);
        if (v) { v.currentTime = 0; if (running && inView) v.play().catch(function () {}); }
        else if (running) timer = setTimeout(function () { show(i + 1); }, 7000);
      }
      slides.forEach(function (s, k) { var v = s.querySelector('video'); if (v) v.addEventListener('ended', function () { if (running) show(k + 1); }); });
      tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      function sync() { var v = vid(i); if (!v) return; if (running && inView) v.play().catch(function () {}); else v.pause(); }
      if (pause) { pause.setAttribute('aria-pressed', String(!running)); pause.firstChild && (pause.textContent = running ? 'Pause motion' : 'Play motion');
        pause.addEventListener('click', function () { running = !running; pause.setAttribute('aria-pressed', String(!running)); pause.textContent = running ? 'Pause motion' : 'Play motion'; sync(); if (running && !vid(i)) show(i + 1); }); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(hero);
      var x0 = null; hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
      show(0); progress();
    }
    function boot() { document.querySelectorAll('[data-leb-hero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leb-product-notes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('variant:update', function (e) {
    var box = document.querySelector('[data-leb-stock]'), map = document.querySelector('[data-leb-stock-map]');
    var v = e.detail && e.detail.resource;
    if (!box || !map || !v) return;
    var state = (JSON.parse(map.textContent)[String(v.id)]) || '';
    box.setAttribute('data-leb-stock', state);
    if (state) box.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
